<div class="home-container container mt-4">
    <!-- Campo de búsqueda -->
    <!-- Contenedor de filtros en línea -->
    <div style="display: flex; gap: 1rem; flex-wrap: wrap; align-items: center;" class="mb-3">

        <!-- Filtro de texto -->
        <mat-form-field appearance="outline" style="flex: 1 1 200px; min-width: 200px;">
            <mat-label>Estado</mat-label>
            <mat-select  [(value)]="statusFilter" (selectionChange)="onStatusChange($event)">
                <mat-option value="" selected>Todos</mat-option>
                <mat-option value="Pending">Pendiente</mat-option>
                <mat-option value="Reserved">Confirmada</mat-option>
                <mat-option value="CheckedIn">Iniciada</mat-option>
                <mat-option value="CheckedOut">Finalizada</mat-option>
                <mat-option value="Cancelled">Cancelada</mat-option>
            </mat-select>
        </mat-form-field>

        <!-- Filtro de texto -->
        <mat-form-field appearance="outline" style="flex: 1 1 200px; min-width: 200px;">
            <mat-label>Buscar</mat-label>
            <input matInput #textSearch (keyup)="applyFilter($event)" placeholder="Buscar reserva..." />
        </mat-form-field>

        <!-- Filtro Check-In -->
        <mat-form-field appearance="outline" style="flex: 1 1 200px; min-width: 200px;">
            <mat-label>Desde (Check-In)</mat-label>
            <input matInput [matDatepicker]="checkInPicker" placeholder="Desde" [value]="filterCheckIn"
                (dateChange)="onCheckInFilterChange($event)" />
            <mat-datepicker-toggle matSuffix [for]="checkInPicker"></mat-datepicker-toggle>
            <mat-datepicker #checkInPicker></mat-datepicker>
        </mat-form-field>

        <!-- Filtro Check-Out -->
        <mat-form-field appearance="outline" style="flex: 1 1 200px; min-width: 200px;">
            <mat-label>Hasta (Check-Out)</mat-label>
            <input matInput [matDatepicker]="checkOutPicker" placeholder="Hasta" [value]="filterCheckOut"
                (dateChange)="onCheckOutFilterChange($event)" />
            <mat-datepicker-toggle matSuffix [for]="checkOutPicker"></mat-datepicker-toggle>
            <mat-datepicker #checkOutPicker></mat-datepicker>
        </mat-form-field>

        <!-- Botón Limpiar -->
        <button mat-stroked-button color="warn" class="custom-btn" (click)="clearFilters(textSearch)">
            Limpiar filtros
        </button>
    </div>


    <!-- Tabla con ordenamiento y acciones -->
    <mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">

        <!-- Responsable (nombre + apellido) -->
        <ng-container matColumnDef="responsible">
            <mat-header-cell *matHeaderCellDef mat-sort-header="responsible"> Responsable </mat-header-cell>
            <mat-cell *matCellDef="let element">
                {{ element.bookingPerson.firstName }} {{ element.bookingPerson.lastName }}
            </mat-cell>
        </ng-container>

        <!-- Teléfono -->
        <ng-container matColumnDef="document">
            <mat-header-cell *matHeaderCellDef mat-sort-header="document"> Documento </mat-header-cell>
            <mat-cell *matCellDef="let element">
                {{ element.bookingPerson.documentType | documentTypeLabel }} - {{ element.bookingPerson.documentNumber
                }}
            </mat-cell>
        </ng-container>

        <!-- Fecha de check-in -->
        <ng-container matColumnDef="checkInDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Check-In </mat-header-cell>
            <mat-cell *matCellDef="let element">
                {{ element.checkInDate | date: 'dd/MM/yyyy' }}
            </mat-cell>
        </ng-container>

        <!-- Fecha de check-out -->
        <ng-container matColumnDef="checkOutDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header> Check-Out </mat-header-cell>
            <mat-cell *matCellDef="let element">
                {{ element.checkOutDate | date: 'dd/MM/yyyy' }}
            </mat-cell>
        </ng-container>
        
        <!-- Nro de reserva -->
        <ng-container matColumnDef="id">
            <mat-header-cell *matHeaderCellDef mat-sort-header="id" class="flex-center"> Reserva Nro.
            </mat-header-cell>
            <mat-cell *matCellDef="let element" class="flex-center"> {{ element.id }} </mat-cell>
        </ng-container>

        <!-- Estado -->
        <ng-container matColumnDef="status">
            <mat-header-cell *matHeaderCellDef mat-sort-header="status" class="flex-center"> Estado </mat-header-cell>
            <mat-cell *matCellDef="let element">
                <span class="reservation-tag {{ descriptionService.reservationStatus(element.status).class }}">
                    {{ descriptionService.reservationStatus(element.status).label }}
                </span>
            </mat-cell>
        </ng-container>
        <!-- Acciones -->
        <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef> Acciones </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Más acciones">
                <mat-icon>more_vert</mat-icon>
              </button>
          
              <mat-menu #menu="matMenu">
                <!-- Ver -->
                <button mat-menu-item (click)="viewReservation(element)">
                  <mat-icon color="primary">visibility</mat-icon>
                  <span>Ver reserva</span>
                </button>
          
                <!-- Registrar pago -->
                <button mat-menu-item (click)="payment(element)" *ngIf="canRegisterPayment(element)">
                  <mat-icon color="success">attach_money</mat-icon>
                  <span>Ingresar pago</span>
                </button>
          
                <!-- Editar -->
                <button mat-menu-item (click)="editReservation(element)" *ngIf="canEdit(element)">
                  <mat-icon color="accent">edit</mat-icon>
                  <span>Editar reserva</span>
                </button>
          
                <!-- Check-in -->
                <button mat-menu-item (click)="checkIn(element)" *ngIf="canCheckIn(element)">
                  <mat-icon class="success">login</mat-icon>
                  <span>Check-In</span>
                </button>
          
                <!-- Check-out -->
                <button mat-menu-item (click)="checkOut(element)" *ngIf="canCheckOut(element)">
                  <mat-icon color="warn">logout</mat-icon>
                  <span>Check-Out</span>
                </button>
          
                <!-- Cancelar -->
                <button mat-menu-item (click)="cancel(element)" *ngIf="canCancel(element)">
                  <mat-icon color="warn">highlight_off</mat-icon>
                  <span>Cancelar</span>
                </button>
              </mat-menu>
            </mat-cell>
          </ng-container>
          

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
    <mat-paginator [length]="totalCount" [pageSize]="pageSize" [pageSizeOptions]="[10, 50, 100]"
        (page)="onPageChange($event)" [showFirstLastButtons]="true">
    </mat-paginator>


</div>